import { useState, useCallback } from 'react';
import { orgSearch } from '../../util/util';
import OrgSearchPicker from '../OrgSearchPicker';

function AdminApplyStepOrg({ orgData, setOrgData, onNext }) {
  const [orgQuery, setOrgQuery] = useState('');
  const [orgs, setOrgs] = useState(null);
  const [mode, setMode] = useState(orgData.orgMode === 'new' ? 'new' : 'search');
  const [error, setError] = useState(null);

  const searchOrgs = useCallback(async () => {
    try {
      const results = await orgSearch(orgQuery);
      if (results) {
        setOrgs(results);
      }
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  }, [orgQuery]);

  const selectOrg = org => {
    setOrgData({ orgMode: 'existing', orgId: org.org_id, orgName: org.org_name, orgBio: '' });
    setOrgs(null);
    setOrgQuery('');
  };

  const switchToNew = () => {
    setMode('new');
    setOrgData({ orgMode: 'new', orgId: null, orgName: '', orgBio: '' });
  };

  const switchToSearch = () => {
    setMode('search');
    setOrgData({ orgMode: 'existing', orgId: null, orgName: '', orgBio: '' });
  };

  const canProceed =
    mode === 'search'
      ? orgData.orgMode === 'existing' && !!orgData.orgId
      : orgData.orgMode === 'new' && !!orgData.orgName.trim();

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-lg font-medium text-slate-700">Which organization is this for?</h2>
      <p className="text-sm text-slate-400">
        Your organization may already be listed on Showrunner. Please search for it below before
        creating a new entry.
      </p>

      {error && <div className="text-xs text-secondary-red">{error}</div>}

      {mode === 'search' && (
        <div className="flex flex-col gap-3">
          <OrgSearchPicker
            orgQuery={orgQuery}
            setOrgQuery={setOrgQuery}
            orgs={orgs}
            onSearch={searchOrgs}
            clearOrgs={() => setOrgs(null)}
            onSelect={selectOrg}
            placeholder="Search for your organization"
          />
          {orgData.orgMode === 'existing' && orgData.orgId && (
            <div className="text-sm text-slate-700">
              Selected: <span className="font-medium">{orgData.orgName}</span>
            </div>
          )}
          <button
            type="button"
            className="text-sm text-secondary-red hover:underline self-start focus:outline-none"
            onClick={switchToNew}
          >
            Don't see it? Create new
          </button>
        </div>
      )}

      {mode === 'new' && (
        <div className="flex flex-col gap-4">
          <div className="flex flex-col">
            <label className="text-sm font-medium text-slate-700 mb-1" htmlFor="orgName">
              Organization Name <span className="text-secondary-red">*</span>
            </label>
            <input
              id="orgName"
              type="text"
              className="input input-bordered text-sm py-2 px-3 h-9 focus:outline-none"
              value={orgData.orgName}
              onChange={e => setOrgData(prev => ({ ...prev, orgName: e.target.value }))}
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-medium text-slate-700 mb-1" htmlFor="orgBio">
              Bio
            </label>
            <textarea
              id="orgBio"
              rows={3}
              className="textarea textarea-bordered text-sm py-2 px-3 focus:outline-none resize-none"
              value={orgData.orgBio}
              onChange={e => setOrgData(prev => ({ ...prev, orgBio: e.target.value }))}
            />
          </div>
          <button
            type="button"
            className="text-sm text-secondary-red hover:underline self-start focus:outline-none"
            onClick={switchToSearch}
          >
            Search for an existing organization instead
          </button>
        </div>
      )}

      <div className="flex justify-end gap-2 mt-2">
        <button
          type="button"
          className="btn btn-primary btn-sm focus:outline-none"
          disabled={!canProceed}
          onClick={onNext}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default AdminApplyStepOrg;
